var render = function render(){var _vm=this,_c=_vm._self._c;return (this.interactResult != null)?_c('iframe',{attrs:{"srcdoc":this.interactResult}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }